import BaseModelAPI from '../BaseModelAPI';

export default class DistributionTypeList extends BaseModelAPI {

	static entity = 'distributiontypelist'
	static entityName = 'distributiontype';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
